var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatMessagesSentLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3742_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66665 2.32812C7.29109 2.33322 6.91998 2.34744 6.55332 2.37078C3.76398 2.54777 1.54265 4.69903 1.35998 7.40035C1.32467 7.93461 1.32467 8.47046 1.35998 9.00472C1.42665 9.98835 1.88198 10.8994 2.41865 11.6685C2.72998 12.2065 2.52465 12.8781 2.19998 13.4658C1.96665 13.8891 1.84932 14.1005 1.94332 14.2533C2.03665 14.4061 2.24665 14.4112 2.66598 14.4207C3.49598 14.4398 4.05532 14.2157 4.49932 13.9031C4.75065 13.7255 4.87665 13.637 4.96332 13.6268C5.04998 13.6166 5.22132 13.6841 5.56265 13.8178C5.86932 13.9388 6.22598 14.0133 6.55265 14.0343C7.50265 14.0941 8.49531 14.0941 9.44731 14.0343C12.236 13.8567 14.4573 11.7054 14.64 9.00472C14.6753 8.4763 14.6753 7.92878 14.64 7.40035C14.6035 6.86214 14.484 6.33203 14.2853 5.82718",
    stroke: "#96989F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 9.9974H10.3334M5.66675 6.66406H8.00008",
    stroke: "#96989F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3742_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 3.56376L11.2884 5.18537L14.8019 1.67188",
    stroke: "#96989F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3742_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3742_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.46875,
    height: 6.46875,
    fill: "white",
    transform: "translate(9 0.195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessagesSentLight);
export default __webpack_public_path__ + "static/media/chat-messages-sent-light.51c47596be375bd63137941f69517e4b.svg";
export { ForwardRef as ReactComponent };